import React from 'react';

export function FuncShareIcon() {
    return (
        <svg
            width="16"
            height="13"
            viewBox="0 0 25 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.8906 0.631218C14.3516 0.87028 14 1.40934 14 1.99997V4.99997H8.75C4.19375 4.99997 0.5 8.69372 0.5 13.25C0.5 18.5609 4.32031 20.9328 5.19687 21.4109C5.31406 21.4765 5.44531 21.5 5.57656 21.5C6.0875 21.5 6.5 21.0828 6.5 20.5765C6.5 20.225 6.29844 19.9015 6.04062 19.6625C5.6 19.2453 5 18.425 5 17C5 14.5156 7.01562 12.5 9.5 12.5H14V15.5C14 16.0906 14.3469 16.6297 14.8906 16.8687C15.4344 17.1078 16.0625 17.0093 16.5031 16.6156L24.0031 9.86559C24.3172 9.57966 24.5 9.17653 24.5 8.74997C24.5 8.32341 24.3219 7.92028 24.0031 7.63434L16.5031 0.884343C16.0625 0.485905 15.4297 0.387468 14.8906 0.631218Z"
                fill="#173300"
            />
        </svg>
    );
}
